import React, { Component } from 'react'
import i18n from 'i18next'

import Checkbox from './Checkbox'
import HoverInfo from '../../UniformComponents/HoverInfo'

import './styles/checkbox-grp.scss'

class CheckboxGroup extends Component {
    constructor(props) {
        super(props)

        if (typeof props.register === 'function') {
            props.register(props.name, this.validate)
        }

        this.values = props.options.reduce((values, { value }) => {
            values[value] = props.defaultChecked.includes(value)
            return values
        }, {})

        this.state = {
            isInValid: false,
        }
    }

    componentWillUnmount() {
        const { unregister, name } = this.props

        if (typeof unregister === 'function') {
            unregister(name)
        }
    }

    validate = (obj, setState = false) => {
        const { isMandatory, validate, name } = this.props

        const hasValue = Object.values(this.values).some((v) => v)
        let isValid = !isMandatory || hasValue
        if (typeof validate === 'function') {
            isValid = isValid && validate({
                value: this.values,
                name,
            })
        }

        if (setState) {
            this.setState({
                isInValid: !isValid,
            })
        }

        return isValid
    }

    onChange = ({ name, value }) => {
        const { onBlur, returnValueUnchanged, radio } = this.props

        if (radio) {
            this.values = { [name]: true }
            onBlur({ name, value })
            this.setState({
                isInValid: !this.validate({ checked: value, name }),
            })
            return
        }

        this.values[name] = value

        this.setState({
            isInValid: !this.validate({ checked: value, name }),
        })

        if (typeof onBlur === 'function') {
            let selections = null

            if (returnValueUnchanged) {
                selections = Object.keys(this.values)
                    .filter((k) => this.values[k])
            } else {
                selections = Object.keys(this.values)
                    .filter((k) => this.values[k])
                    .map((k) => parseInt(k, 10))
            }

            onBlur({ value: selections, name: this.props.name, type: 'checkboxgroup' })
        }
    }

    isDefaultChecked = (value) => {
        const { radio, isNotDefaultChecked } = this.props

        let defaultValue = radio ? undefined : this.values[value]

        if (isNotDefaultChecked) {
            defaultValue = undefined
        }

        return defaultValue
    }

    isChecked = (value) => {
        const { radio, isNotDefaultChecked, radioValue } = this.props

        let checked = radio ? radioValue === value : undefined

        if (isNotDefaultChecked) {
            checked = this.values[value]
        }

        return checked
    }

    render() {
        const {
            options, emptyError, defaultChecked, refreshOnRender, label, cssClass, radio, radioValue,
        } = this.props
        const { isInValid } = this.state

        if (refreshOnRender) {
            this.values = options.reduce((values, { value }) => {
                values[value] = defaultChecked.includes(value)
                return values
            }, {})
        }

        return (
            <div
                className={`form-checkbox-grp ${cssClass} ${isInValid ? 'validation-error' : ''}`}
            >
                <label className="checkbox-grp-label">
                    {label}
                </label>
                {options.map(({ value, label, disabled }) => (
                    <div style={{ position: 'relative' }}>
                        <Checkbox
                            name={value}
                            label={label}
                            onBlur={this.onChange}
                            defaultChecked={radio ? undefined : this.values[value]}
                            key={value}
                            checked={radio ? radioValue === value : undefined}
                            disabled={disabled}
                        />
                        {disabled && (
                            <div style={{ position: 'absolute', top: 9, left: 1 }}>
                                <HoverInfo
                                    cssClass="hover-info"
                                    desc={i18n.t('rapidSurvey.disabledFeatureTitle')}
                                    linkText={i18n.t('rapidSurvey.disabledFeatureBody')}
                                    href="mailto:support@explori.com"
                                    dir="right"
                                >
                                    <i className="fas fa-lock-keyhole" style={{ color: '#715AF8', fontSize: 16 }} />
                                </HoverInfo>
                            </div>
                        )}
                    </div>
                ))}
                {isInValid && (
                    <div
                        className="errorMsg"
                        style={{
                            color: '#df107f',
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        {emptyError}
                        {' '}
                        <i className="fal fa-exclamation-circle fa-fw" />
                    </div>
                )}
            </div>
        )
    }
}

export default CheckboxGroup
